// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3bLmR","rootSmall":"AddTileButton_rootSmall__3uRDR"};